import { render, staticRenderFns } from "./Upload.vue?vue&type=template&id=4e2d16e6&scoped=true&"
import script from "./Upload.vue?vue&type=script&lang=js&"
export * from "./Upload.vue?vue&type=script&lang=js&"
import style0 from "./Upload.vue?vue&type=style&index=0&id=4e2d16e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d16e6",
  null
  
)

export default component.exports